'use client';
import * as React from 'react';
import { useTranslations } from 'next-intl';
import { ApiError } from '@/lib/api';

const KNOWN = ['UNAUTHORIZED', 'FORBIDDEN', 'NOT_FOUND', 'VALIDATION', 'QUOTA_EXCEEDED', 'VERSION_CONFLICT', 'RATE_LIMITED', 'CONFLICT', 'INTERNAL'];

/**
 * Turns any thrown value into a localised message from the `errors.*` namespace.
 *
 * Memoised on purpose. Callers put this function in `useCallback`/`useEffect` dependency lists, so
 * a fresh identity on every render re-runs their fetch effect, whose state update renders again —
 * the album list span 92 requests in 1.5 s that way (docs/10-ux-audit.md · UX-06).
 */
export function useApiErrorMessage(): (err: unknown) => string {
  const t = useTranslations('errors');
  return React.useCallback(
    (err: unknown): string => {
      if (err instanceof ApiError) {
        if (KNOWN.includes(err.code)) return t(err.code as 'INTERNAL');
        if (err.status === 0) return t('NETWORK');
      }
      return t('UNKNOWN');
    },
    [t],
  );
}
